<template>
    <div class="l-ss-c-image-search">
        <div class="l-ss-c-widget-image-search">
            <popup
                v-if="$configuration.features.imageSearch"
                :opened="openedPopup"
                :title="$t('imageSearch.title')"
                class="l-ss-c-search-popup-image-search-popup"
                @close="() => toggleImageSearch(false )">
                <image-search-container
                    @search="onImageSearch"
                    @image-search-button-select-file-click="value => $emit('image-search-button-select-file-click', value)"
                    @image-search-use-correct-link-click="value => $emit('image-search-use-correct-link-click', value)"
                    @image-search-use-incorrect-link-click="value => $emit('image-search-use-incorrect-link-click', value)"
                    @image-search-button-search-click="value => $emit('image-search-button-search-click', value)"/>
            </popup>
        </div>
    </div>
</template>
<script>
    import ImageSearchContainer from '../core/components/image-search-container';
    import RootComponentMixin from '../core/mixins/root-component';
    import Popup from '../core/components/popup';

    export default {
        components: {
            ImageSearchContainer,
            Popup,
        },
        provide: RootComponentMixin.provide,
        props: {
            ...RootComponentMixin.props,
        },
        computed: {
            ...RootComponentMixin.computed,
            openedPopup() {
                return this.store.state.ui.isImageSearchWidgetVisible &&
                    this.store.state.ui.isNameWidgetActive.toUpperCase() === this.$root.$options.customElement.nodeName.toUpperCase();
            },
        },
        watch: {
            'store.state.ui.isCompletionsVisible': {
                handler(value) {
                    if (value && !this.isFocused && this.value) {
                        this.$refs.input.focus();
                        this.isFocused = true;
                    }
                },
            },
            'store.state.ui.isImageSearchVisible': {
                handler(value) {
                    if (!value) {
                        this.$emit('reset-position');
                    }
                },
            },
            'store.state.ui.isImageSearchLoader': {
                handler(value) {
                    this.$emit('loader-image', { value: value });
                },
            },

        },
        methods: {
            ...RootComponentMixin.methods,
            onImageSearch(baseImage) {
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchWidgetVisible', value: false });
                this.$emit('search-image', { base64: baseImage });
            },
            toggleImageSearch(value) {
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchWidgetVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isImageSearchVisible',
                    value: value === undefined ? !this.store.state.ui.isImageSearchVisible : !!value,
                });
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchLoader', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
            },
        },
    };
</script>
